var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57437 6.10179C3.88482 5.76312 4.41104 5.74024 4.74971 6.05069L14.1701 14.686L23.5905 6.05069C23.9291 5.74024 24.4554 5.76312 24.7658 6.10179C25.0763 6.44046 25.0534 6.96668 24.7147 7.27713L14.7322 16.4278C14.4142 16.7193 13.926 16.7193 13.608 16.4278L3.62547 7.27713C3.2868 6.96668 3.26392 6.44046 3.57437 6.10179Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35571 6.66391C3.35571 6.20447 3.72816 5.83203 4.18759 5.83203H24.1526C24.612 5.83203 24.9845 6.20447 24.9845 6.66391V20.8058C24.9845 21.247 24.8092 21.6702 24.4972 21.9822C24.1851 22.2942 23.762 22.4695 23.3207 22.4695H5.01946C4.57821 22.4695 4.15503 22.2942 3.84301 21.9822C3.531 21.6702 3.35571 21.247 3.35571 20.8058V6.66391ZM5.01946 7.49578V20.8058H23.3207V7.49578H5.01946Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9635 13.5899C13.274 13.9285 13.2513 14.4547 12.9127 14.7653L5.00987 22.013C4.67127 22.3235 4.14505 22.3008 3.83452 21.9622C3.52399 21.6236 3.54674 21.0973 3.88534 20.7868L11.7882 13.5391C12.1267 13.2286 12.653 13.2513 12.9635 13.5899Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3768 13.5899C15.6873 13.2513 16.2135 13.2286 16.5521 13.5391L24.4549 20.7868C24.7935 21.0973 24.8163 21.6236 24.5057 21.9622C24.1952 22.3008 23.669 22.3235 23.3304 22.013L15.4276 14.7653C15.089 14.4547 15.0662 13.9285 15.3768 13.5899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.1d23f01d82ec1511087386f11ae3ba44.svg";
export { ForwardRef as ReactComponent };